<template>
  <div>
    <div id="map" :style="{ width: width + 'px', height: height + 'px' }">
      <v-map ref="map" :zoom="zoom" :center="center" :minZoom="3" :worldCopyJump="true">
        <v-tilelayer :url="url"></v-tilelayer>
        <v-choropleth-layer @click:item="clickItem($event)" :data="mapData" titleKey="NUTS_NAME" idKey="region_code"
                            :value="value" geojsonIdKey="NUTS_ID" :geojson="geoJSON" :colorScale="colorScale"
                            :gradients="gradients">
          <template slot-scope="props">
            <!-- <v-info-control :item="props.currentItem" :unit="props.unit" :title="info.title" :placeholder="'Hover over a ' + info.title" position="bottomleft"/> -->
            <v-reference-chart :title="refChart.title" :colorScale="colorScale" :min="props.min" :max="props.max"
                               position="topright" :gradients="gradients"/>
          </template>
        </v-choropleth-layer>
      </v-map>
    </div>
  </div>
</template>

<script>
import chroma from 'chroma-js'
import Geostats from 'geostats'
import * as topojson from 'topojson'
import Vue2Leaflet from 'vue2-leaflet'
import {InfoControl} from 'vue-choropleth'
import ChoroplethLayer from './ChoroplethLayer'
import Legend from './Legend'
import L from 'leaflet'
import {NO_NORM} from '../constants'
import Vue from 'vue'

require('leaflet-easyprint')

// // fixes bug where marker is not displayed
// delete L.Icon.Default.prototype._getIconUrl
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// })

export default {
  name: 'map-chart',
  props: ['chartData', 'width', 'height'],
  components: {
    'v-map': Vue2Leaflet.Map,
    'v-tilelayer': Vue2Leaflet.TileLayer,
    'v-marker': Vue2Leaflet.Marker,
    'v-geojson-layer': Vue2Leaflet.GeoJSON,
    'v-info-control': InfoControl,
    'v-reference-chart': Legend,
    'v-choropleth-layer': ChoroplethLayer
  },
  created: function () {
    this.updateChart()
  },
  computed: {
    mapData () {
      return this.getData()
    },

    geoJSON () {
      const topoJSON = Vue.prototype.$constants.TOPO_JSON

      let geoJSON
      for (let key in topoJSON.objects) {
        geoJSON = topojson.feature(topoJSON, topoJSON.objects[key])
      }
      return geoJSON
    },
    selectedIndicator () {
      return this.$store.state.selectedIndicator
    },
    selectedNormalization () {
      return this.$store.state.selectedNormalization
    }
  },
  mounted: function () {
    // call invalidateSize() after mounting, to fix bug where map is not correctly displayed in tab
    this.resize()
    // set zIndex to 0, to fix bug where map overlaps toolbar during vertical scrolling
    this.$refs.map.mapObject._container.style.zIndex = 0
    // hide 'leaflet' attribution in bottom right corner
    this.$refs.map.mapObject.attributionControl._container.hidden = true

    // console.log(this.$refs.map.mapObject)
    L.easyPrint({
      title: 'KNOWMAK map',
      sizeModes: ['Current', 'A4Landscape', 'A4Portrait'],
      filename: 'knowmak-map',
      exportOnly: true,
      hideControlContainer: false
    }).addTo(this.$refs.map.mapObject)
  },
  data () {
    return {
      zoom: 3.5,
      center: [55, 10],
      url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      colorScale: null,
      gradients: null,
      value: {
        key: 'value',
        metric: ''
      },
      info: {
        title: 'Region'
      },
      refChart: {
        title: ''
      },
      noNorm: NO_NORM
    }
  },
  methods: {
    clickItem (item) {
      this.$emit('click:item', item)
    },
    updateChart () {
      let legendTitle = this.selectedIndicator.text

      if (this.selectedNormalization.id !== this.noNorm.id) {
        legendTitle += ' ' + this.selectedNormalization.value
      }

      this.refChart.title = legendTitle

      let classes = this.chartData.data.length > 5 ? 5 : this.chartData.data.length
      this.colorScale = chroma.scale('YlOrRd').colors(classes) // orange: ['#e7d090', '#de7062'], blue: ['#d0d1e6', '#034e7b']
      // empty colorScale if no data is present
      if (classes === 0) {
        this.colorScale = []
      }
    },
    getData () {
      let firstDim = this.chartData.group_by[0]
      let reformattedData = this.chartData.data.map(function (d) {
        return {'region_code': d[firstDim], 'value': d.value == null ? null : +d.value}
      })

      // array with values only
      let dataValues = reformattedData.map(function (d) {
        return d.value
      })

      // avoid empty array for geostats if no data is present
      if (dataValues.length === 0) {
        dataValues = [0]
      }

      // generate statistic population for data values
      this.gradients = new Geostats(dataValues)
      // if values are float -> set precision to 2
      if (dataValues[0] % 1 !== 0) {
        this.gradients.setPrecision(2)
      }
      // get classes for number of colors
      this.gradients.getClassArithmeticProgression(this.colorScale.length)

      // fix to color maxValue-region correctly -> change last value in bounds array to maxValue of dataValues
      // necessary because .getClassArithmeticProgression() wrongly calculates max bound value
      let bounds = this.gradients.bounds
      bounds[bounds.length - 1] = Math.max(...dataValues)
      this.gradients.setBounds(bounds)
      this.gradients.setRanges()

      return reformattedData
    },
    resize () {
      let that = this
      setTimeout(function () {
        that.$refs.map.mapObject.invalidateSize()
      }, 0)
    }
  },
  watch: {
    chartData: {
      handler: 'updateChart'
      // deep: true
    },
    width: 'resize'
  }
}
</script>

<style src="leaflet/dist/leaflet.css">
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Map.vue